import { render, staticRenderFns } from "./userTotal.vue?vue&type=template&id=566fa19c&"
import script from "./userTotal.vue?vue&type=script&lang=js&"
export * from "./userTotal.vue?vue&type=script&lang=js&"
import style0 from "./userTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports